import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, AlertController } from 'ionic-angular';


import { Storage } from '@ionic/storage';
import { WpProvider } from "../../providers/wp/wp";

import { InRoomDiningOrderModal, IrdOrder, IrdOrderItem } from './in-room-dining-order';

import { InRoomDiningServiceProvider } from './in-room-dining-service';
import { PhcInRoomDiningMenuItem } from '../../classes/phc-app/phc-app';
import { TabUpdateProvider } from '../../providers/tab-update/tab-update.service';


/**
 * Generated class for the InRoomDiningPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-in-room-dining',
  templateUrl: 'in-room-dining.html',
})
export class InRoomDiningPage {

  phcApp;
  rs;
  activeMenu;
  currentOrder: IrdOrder;

  menus = [];

  private availabilityObserver;

  constructor(
    private modalCtrl: ModalController,
    private navCtrl: NavController,
    private navParams: NavParams,
    private wpProvider: WpProvider,
    private storage: Storage,
    private irdService: InRoomDiningServiceProvider,
    private alertCtrl: AlertController,
    private tabUpdate: TabUpdateProvider
  ) {
    this.phcApp = wpProvider.app;
    this.rs = this.phcApp.in_room_dining;
    console.log(this.rs);
    this.menus = this.rs.ird_menus;
    // this.filterAvailableMenus();
    // this.observeAvailableMenus();
    if (this.menus && this.menus.length === 1){
      this.activeMenu = this.menus[0];
    }

  }

  private observeAvailableMenus(){
    console.log('Starting observer');
    this.availabilityObserver = setInterval(() => {
      console.log('filtering...');
      this.filterAvailableMenus();
    }, 30000);
  }

  private filterAvailableMenus() {
    this.menus = this.rs.ird_menus;
    console.log(this.menus);
      //.filter(menu => this.isMenuAvailable(menu));
  }

  private isMenuAvailable(menu){

    const convertTime12to24 = (time12h) => {
      const [time, modifier] = time12h.split(' ');

      let [hours, minutes] = time.split(':');

      if (hours === '12') {
        hours = '00';
      }

      if (modifier.toUpperCase() === 'PM') {
        hours = parseInt(hours, 10) + 12;
      }

      return [parseInt(hours, 10), parseInt(minutes, 10)];
    };

    const date = new Date();
    if(menu && menu.availability && menu.availability.enable_availability){
      const start = convertTime12to24(menu.availability.hours.starting_time);
      const end = convertTime12to24(menu.availability.hours.ending_time);
      const now = [date.getHours(), date.getMinutes()];
      console.log(start, end, now);
      const startSeconds = (start[0] * 60 * 60) + (start[1] * 60);
      const endSeconds = (end[0] * 60 * 60) + (end[1] * 60);
      const nowSeconds = (now[0] * 60 * 60) + (now[1] * 60);
      console.log(startSeconds, endSeconds, nowSeconds);
      if (nowSeconds < startSeconds || nowSeconds > endSeconds) {
        return false;
      }
    }
    return true;
  }

  isItemInMenu(item: PhcInRoomDiningMenuItem) {
    if (this.currentOrder && this.currentOrder.items.length) {
      for (let i = 0; i <= this.currentOrder.items.length - 1; i++) {
        let irdItem: IrdOrderItem = this.currentOrder.items[i];
        if (irdItem.item === item) {
          return true;
        }
      }
    }
  }

  openOrder() {
    let orderModal = this.modalCtrl.create(InRoomDiningOrderModal, { order: this.currentOrder, ird: this.rs });
    orderModal.onDidDismiss(order => {
      if (order) {
        console.log(order);
        this.currentOrder = order;
        if (this.currentOrder.complete) {
          this.submitOrder(this.currentOrder);
        }
      }
    });
    orderModal.present();
  }

  getSectionItems(sectionIds){
    return this.phcApp.getIrdMenuItems(sectionIds).filter(item => item.prices && item.prices[0]);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InRoomDiningPage');
  }

  ionViewDidLeave() {
    clearInterval(this.availabilityObserver);
  }

  menuCardBgStyle(menu){
    return {
      boxShadow: `inset 0 0 0 1000px rgba(0,0,0,${ parseInt(menu.black_overlay_opacity) / 100 })`,
    }
  }

  addToOrder(item){
    console.log(item);
    if(!this.currentOrder || !this.currentOrder.ready()){
      this.openOrder();
    }else{
      let orderItem = new IrdOrderItem(item);
      orderItem.addToOrder(this.currentOrder);
      this.openOrder();
    }
  }

  submitOrder(order){
    this.irdService.submitOrder(order);
    order.clear();
    this.activeMenu = null;
    alert('Thank you! Your order is being prepared');
    this.tabUpdate.tabUpdates.next(0);
  }

  doneOrder(){
    alert('Thank you! Your order is on its way.');
  }

  activateMenu(menu){
    console.log(menu);
    this.activeMenu = menu;
  }

  getMenuAvailability(menu){
    if(menu && menu.availability && menu.availability.enable_availability){
      return `${menu.availability.hours.starting_time} - ${menu.availability.hours.ending_time} `
    }
    return '';
  }
  ngOnInit(){
    /*
      let fixText = setInterval(() => {
        if (this.rs.ird_menus && this.rs.ird_menus.length > 2 &&  document.querySelectorAll('.ird-menus .card-title').length) {
          clearInterval(fixText);
          console.log('fixing!');
          setTimeout(()=>{
            fitty('.ird-menus .card-title', {
              minSize: 22,
              multiLine: true
            });
          }, 500);
        }
      }, 500);
*/
  }

  get showAlertMessage() {
    if (this.currentOrder && this.currentOrder.items && this.currentOrder.items.length) {
      return true;
    }
    return false;
  }

  ionViewCanLeave(): Promise<void> {
    return new Promise((resolve, reject) => {

      if (!this.showAlertMessage) {
        return resolve();
      }

      let confirm = this.alertCtrl.create({
        title: 'Are you sure you want to exit?',
        message: 'Your current order will be deleted.',
        buttons: [{
          text: 'Go Back',
          handler: () => {
            resolve();
          },
        }, {
          text: 'Stay',
          handler: () => {
            reject();
          }
        }],
      });
      confirm.present();
    })
  }

}



// WEBPACK FOOTER //
// ./src/pages/in-room-dining/in-room-dining.ts